export { EstatePlanningRecommendationQuizRecommendationStepTemplate } from './Template';
